import React from 'react';
import T from 'prop-types';
import { useHistory } from 'react-router-dom';

import { Button } from 'antd';

const ButtonRouter = ({ children, to, ...props }) => {
  const history = useHistory();

  return (
    <Button {...props} onClick={() => history.push(to)}>
      {children}
    </Button>
  );
};

ButtonRouter.propTypes = {
  children: T.node.isRequired,
  to: T.string.isRequired,
};

export default ButtonRouter;
